import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import SkinViewer from "./SkinViewer";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import { BsTelegram } from "react-icons/bs";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Ciao a tutti!{" "}
                <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻
                </span>
              </h1>

              <h1 className="heading-name">
                Sono
                <strong className="main-name"> ImMaster__</strong>
              </h1>

              <div style={{ padding: 50, textAlign: "left", fontSize: "22px" }}>
                <Type />
              </div>
            </Col>

            <Col md={5} style={{ paddingBottom: 20 }}>
                <SkinViewer />
            </Col>
          </Row>
        </Container>
      </Container>
      <Home2 />

      <Container>
        <Row style={{ paddingTop: "50px", paddingBottom: "80px" }}>
          <Col md={12} className="home-about-social">
            <h1>Contatti</h1>
            <p>
              Desideri un <span className="purple">portfolio </span>come questo? Scrivimi.
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://t.me/PlayerMasters" 
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <BsTelegram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Home;
